export const API_HOSTNAME = import.meta.env.VITE_API_HOSTNAME
export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME ?? 'LineageOS'
export const WIKI_URL = import.meta.env.VITE_WIKI_URL
export const SIGNING_KEY_FINGERPRINT =
  import.meta.env.VITE_SIGNING_KEY_FINGERPRINT ??
  '72:96:32:27:d6:6c:4c:4d:5f:a0:91:6a:c2:2c:79:3c:d4:5f:43:5c'
export const BRAND_COLOR_LIGHT = import.meta.env.VITE_BRAND_COLOR_LIGHT
export const BRAND_COLOR_DARK = import.meta.env.VITE_BRAND_COLOR_DARK
export const BRAND_COLOR_PRIMARY = import.meta.env.VITE_BRAND_COLOR_PRIMARY
export const LOGO_SVG = import.meta.env.VITE_LOGO_SVG
export const FAVICON_URL = import.meta.env.VITE_FAVICON_URL
